import type { IndeedIntegrationSettings } from 'api-clients/monolith';

export type HeldIndeedToggles = {
  changed: Partial<
    Pick<
      IndeedIntegrationSettings,
      | 'indeed_xml_feed_enabled'
      | 'indeed_apply_enabled'
      | 'sourcing_title_source'
    >
  >;
  startedAt: number;
};

const KEY = 'source.indeed.connect';

export function writeHeldToggles(
  changed: HeldIndeedToggles['changed'],
  now = Date.now(),
): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ changed, startedAt: now }));
  } catch {
    /* Storage can be unavailable. */
  }
}

export function takeHeldToggles(now = Date.now()): HeldIndeedToggles | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    if (!raw) return null;
    const value: unknown = JSON.parse(raw);
    if (
      !value ||
      typeof value !== 'object' ||
      !('startedAt' in value) ||
      typeof value.startedAt !== 'number' ||
      !Number.isFinite(value.startedAt) ||
      now - value.startedAt > 15 * 60 * 1000 ||
      value.startedAt > now ||
      !('changed' in value) ||
      !value.changed ||
      typeof value.changed !== 'object' ||
      Array.isArray(value.changed)
    )
      return null;
    const changed = value.changed as Record<string, unknown>;
    if (
      Object.keys(changed).some(
        key =>
          ![
            'indeed_xml_feed_enabled',
            'indeed_apply_enabled',
            'sourcing_title_source',
          ].includes(key),
      ) ||
      (changed.indeed_xml_feed_enabled !== undefined &&
        typeof changed.indeed_xml_feed_enabled !== 'boolean') ||
      (changed.indeed_apply_enabled !== undefined &&
        typeof changed.indeed_apply_enabled !== 'boolean') ||
      (changed.sourcing_title_source !== undefined &&
        changed.sourcing_title_source !== 'funnel_title' &&
        changed.sourcing_title_source !== 'position_title')
    )
      return null;
    return value as HeldIndeedToggles;
  } catch {
    return null;
  }
}
